import { SetupObservability } from '@/Pages/Onboarding/components/SetupObservability';
import { Pane } from '@/components/Pane';

export function NewProjectPane(props: { open: boolean; onClose: () => void }) {
  return (
    <Pane open={props.open} onClose={props.onClose} title="">
      <SetupObservability />
    </Pane>
  );
}
